import React, { useState, useEffect } from "react";
import {
  Box,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Badge,
  Collapse,
  Divider,
  ListSubheader,
} from "@mui/material";

//styles and theme
import { useTheme } from "@mui/material/styles";
import { BrowserView, MobileView } from "react-device-detect";
import PerfectScrollbar from "react-perfect-scrollbar";
import Can from "../../../helpers/Can";
//icons
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { AiOutlineClear, AiOutlineHome } from "react-icons/ai";

import { useLocation, useNavigate } from "react-router-dom";
import { RiCustomerService2Fill } from "react-icons/ri";
import {
  TbEaseInOutControlPoints,
  TbReportSearch,
  TbServer2,
  TbSocial,
} from "react-icons/tb";
import { HiOutlineCreditCard } from "react-icons/hi";
import { FiUsers } from "react-icons/fi";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { RiShieldUserLine } from "react-icons/ri";
import { BiTask } from "react-icons/bi";
import {
  GrHostMaintenance,
  GrStatusUnknown,
  GrTransaction,
} from "react-icons/gr";
import { LiaBroadcastTowerSolid } from "react-icons/lia";
import { IoMdRefresh } from "react-icons/io";
import { VscVariableGroup } from "react-icons/vsc";
import { FaRegChartBar, FaUpload } from "react-icons/fa";
import { BiSolidOffer } from "react-icons/bi";
import { TfiAnnouncement } from "react-icons/tfi";
import { LuUtilityPole, LuWallet } from "react-icons/lu";
import { TbTransform } from "react-icons/tb";

//store
import { useDispatch, useSelector } from "react-redux";
import { setDrawer } from "../../../app/slices/appSlice";
import { MdAttachMoney, MdStars } from "react-icons/md";

const SideBar = () => {
  const {
    user: {
      info: { permissions },
    },
  } = useSelector((state) => state.profile);
  const {
    task_notifications: { new_customer, maintenance, subscription_request },
  } = useSelector((state) => state.task);

  //uses
  const theme = useTheme();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //constants
  const drawerWidth = 220;

  //states
  const [open, setOpen] = useState(false);
  const [selectedID, setSelectedID] = useState(null);
  // const [mobileOpen, setMobileOpen] = useState(false);

  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const drawerOpen = useSelector((state) => state.app.is_drawer_opened);

  // const links = [
  //   {
  //     id: 1,
  //     name: "الرئيسية",
  //     icon: <AiOutlineHome size={18} />,
  //     path: "/",
  //     sub: [],
  //     roles: [],
  //     can: "",
  //   },
  //   {
  //     id: 210,
  //     name: "الأحصائيات",
  //     icon: <FaRegChartBar size={18} />,
  //     path: "/statistics",
  //     sub: [],
  //     roles: ["Manager"],
  //     can: "statistic_view",
  //   },
  //   // {
  //   //   id: 2,
  //   //   name: "حالة الخدمات",
  //   //   icon: <HiOutlineStatusOnline size={18} />,
  //   //   path: "/services-status",
  //   //   sub: [],
  //   //   roles: ["Manager"],
  //   //   can: "service_status",
  //   // },
  //   {
  //     id: 3,
  //     name: "الصلاحيات",
  //     icon: <RiShieldUserLine size={18} />,
  //     path: "/roles-permissions",
  //     sub: [],
  //     can: "management",
  //   },
  //   {
  //     id: 4,
  //     name: "الموظفين",
  //     icon: <HiOutlineBuildingOffice size={18} />,
  //     path: "/users",
  //     sub: [],
  //     can: "user_manage",
  //   },
  //   {
  //     id: 5,
  //     name: "المشتركين",
  //     icon: <FiUsers size={18} />,
  //     path: "/customers",
  //     sub: [],
  //     can: "customer_view",
  //   },
  //   {
  //     id: 7,
  //     name: "الاشتراكات",
  //     icon: <HiOutlineCreditCard size={20} />,
  //     path: "/subscriptions",
  //     sub: [],
  //     can: "subscription_view",
  //   },
  //   {
  //     id: 120,
  //     name: "الوكلاء",
  //     icon: <LiaBroadcastTowerSolid size={18} />,
  //     path: "/clients",
  //     sub: [],
  //     can: "client_view",
  //   },
  //   {
  //     id: 133,
  //     name: "المعاملات الماليه",
  //     icon: <GrTransaction size={18} />,
  //     path: "/transactions",
  //     sub: [],
  //     can: "client_transaction_view",
  //   },
  //   {
  //     id: 6,
  //     name: "خدمة المشتركين",
  //     icon: <RiCustomerService2Fill size={18} />,
  //     path: "/call-customer-history",
  //     sub: [],
  //     can: "customer_call_history",
  //   },
  //   {
  //     id: 499,
  //     name: "اسعار الاشتراكات",
  //     icon: <MdAttachMoney size={18} />,
  //     path: "/subscriptions-price",
  //     sub: [],
  //     can: "subscription_price_manage",
  //   },
  //   {
  //     id: 40,
  //     name: "عروض الاشتراكات",
  //     icon: <BiSolidOffer size={18} />,
  //     path: "/offers",
  //     sub: [],
  //     can: "offers",
  //   },
  //   // {
  //   //   id: 8,
  //   //   name: "سحب الاجهزة",
  //   //   icon: <BsRouter size={20} />,
  //   //   path: "/expiry-customers",
  //   //   sub: [],
  //   //   can: "customer_expired_view",
  //   // },
  //   {
  //     id: 9,
  //     name: "الكابينات و الاعمدة",
  //     icon: <TbServer2 size={18} />,
  //     path: "/cabinets",
  //     sub: [],
  //     can: "cabinet_view",
  //   },
  //   // {
  //   //   id: 10,
  //   //   name: "التذاكر",
  //   //   icon: <IoTicketOutline size={18} />,
  //   //   path: "/tickets",
  //   //   sub: [],
  //   //   can: "ftth_ticket",
  //   // },
  //   {
  //     id: 11,
  //     name: "طلبات النصب",
  //     icon: <BiTask size={18} />,
  //     path: "/task",
  //     sub: [],
  //     is_badge: true,
  //     can: "task_new_customers_view",
  //   },
  //   {
  //     id: 20,
  //     name: "طلبات التجديد ",
  //     icon: <IoMdRefresh size={18} />,
  //     path: "/subscription-request-task",
  //     sub: [],
  //     is_badge: true,
  //     can: "task_subscription_request",
  //   },
  //   {
  //     id: 12,
  //     name: "مهام الصيانة",
  //     icon: <GrHostMaintenance size={18} />,
  //     path: "/maintenance-task",
  //     sub: [],
  //     is_badge: true,
  //     can: "task_maintenance_view",
  //   },
  //   {
  //     id: 11209,
  //     name: "صيانة الاعمدة",
  //     icon: <LuUtilityPole size={18} />,
  //     path: "/fat-maintenance",
  //     sub: [],
  //     is_badge: false,
  //     can: "is_maintenance_support",
  //   },
  //   {
  //     id: 11209,
  //     name: "مهام التصفية",
  //     icon: <AiOutlineClear size={18} />,
  //     path: "/fat-clearance-task",
  //     sub: [],
  //     is_badge: false,
  //     can: "clearance_task_view",
  //   },
  //   {
  //     id: 1226,
  //     name: "محافظ الموظفين",
  //     icon: <LuWallet size={18} />,
  //     path: "/user-wallet",
  //     sub: [],
  //     can: "wallet_view",
  //   },
  //   {
  //     id: 1221,
  //     name: "حركة المحافظ",
  //     icon: <TbTransform size={18} />,
  //     path: "/wallet-transaction",
  //     sub: [],
  //     can: "wallet_transactions",
  //   },
  //   // {
  //   //   id: 11200,
  //   //   name: "تقييم اداء الصيانة",
  //   //   icon: <FaGlasses size={18} />,
  //   //   path: "/qa",
  //   //   sub: [],
  //   //   can: "is_quality",
  //   // },
  //   {
  //     id: 14,
  //     name: "خدمات الوكلاء",
  //     icon: <TbSocial size={18} />,
  //     path: "/subscription-service",
  //     sub: [],
  //     can: "client_subscription_service_view",
  //   },
  //   {
  //     id: 13,
  //     name: "التقارير",
  //     icon: <TbReportSearch size={18} />,
  //     path: "/reports",
  //     sub: [],
  //     can: "report_view",
  //   },
  //   {
  //     id: 30,
  //     name: "المتغيرات",
  //     icon: <VscVariableGroup size={18} />,
  //     path: "/variables",
  //     sub: [],
  //     can: "update_variables",
  //   },
  //   {
  //     id: 3789,
  //     name: "الأعلانات",
  //     icon: <TfiAnnouncement size={18} />,
  //     path: "/announcements",
  //     sub: [],
  //     can: "announcements",
  //   },
  //   {
  //     id: 3790,
  //     name: "المناطق ( الزون )",
  //     icon: <TbEaseInOutControlPoints size={18} />,
  //     path: "/ftth-panels",
  //     sub: [],
  //     roles: [],
  //     can: "",
  //   },
  //   {
  //     id: 1128,
  //     name: "رفع التطبيق",
  //     icon: <FaUpload size={20} />,
  //     path: "/apk",
  //     sub: [],
  //     can: "upload_apk",
  //   },
  // ];

  const links = [
    // ================== المجموعة: الاساسية ==================
    {
      id: 1,
      groupTitle: "الاساسية",
      name: "الرئيسية",
      icon: <AiOutlineHome size={18} />,
      path: "/",
      sub: [],
      roles: [],
      can: "",
    },
    {
      id: 210,
      groupTitle: "الاساسية",
      name: "الأحصائيات",
      icon: <FaRegChartBar size={18} />,
      path: "/statistics",
      sub: [],
      roles: ["Manager"],
      can: "statistic_view",
    },
    {
      id: 5,
      groupTitle: "الاساسية",
      name: "المشتركين",
      icon: <FiUsers size={18} />,
      path: "/customers",
      sub: [],
      can: "customer_view",
    },
    {
      id: 7,
      groupTitle: "الاساسية",
      name: "الاشتراكات",
      icon: <HiOutlineCreditCard size={20} />,
      path: "/subscriptions",
      sub: [],
      can: "subscription_view",
    },
    {
      id: 6,
      groupTitle: "الاساسية",
      name: "خدمة المشتركين",
      icon: <RiCustomerService2Fill size={18} />,
      path: "/call-customer-history",
      sub: [],
      can: "customer_call_history",
    },
    {
      id: 13,
      groupTitle: "الاساسية",
      name: "التقارير",
      icon: <TbReportSearch size={18} />,
      path: "/reports",
      sub: [],
      can: "report_view",
    },

    // ================== المجموعة: المهام ==================
    {
      id: 11,
      groupTitle: "المهام",
      name: "طلبات النصب",
      icon: <BiTask size={18} />,
      path: "/task",
      sub: [],
      is_badge: true,
      can: "task_new_customers_view",
    },
    {
      id: 20,
      groupTitle: "المهام",
      name: "طلبات التجديد ",
      icon: <IoMdRefresh size={18} />,
      path: "/subscription-request-task",
      sub: [],
      is_badge: true,
      can: "task_subscription_request",
    },
    {
      id: 12,
      groupTitle: "المهام",
      name: "مهام الصيانة",
      icon: <GrHostMaintenance size={18} />,
      path: "/maintenance-task",
      sub: [],
      is_badge: true,
      can: "task_maintenance_view",
    },
    {
      id: 11210,
      groupTitle: "المهام",
      name: "مهام الجودة",
      icon: <MdStars size={18} />,
      path: "/ticket-quality",
      sub: [],
      is_badge: false,
      can: "ticket_quality_view",
    },
    {
      id: 11209,
      groupTitle: "المهام",
      name: "صيانة الاعمدة",
      icon: <LuUtilityPole size={18} />,
      path: "/fat-maintenance",
      sub: [],
      is_badge: false,
      can: "is_maintenance_support",
    },
    {
      id: 11209,
      groupTitle: "المهام",
      name: "مهام التصفية",
      icon: <AiOutlineClear size={18} />,
      path: "/fat-clearance-task",
      sub: [],
      is_badge: false,
      can: "clearance_task_view",
    },
    {
      id: 11209,
      groupTitle: "المهام",
      name: "مهام غير معروفة",
      icon: <GrStatusUnknown size={18} />,
      path: "/unknown-task",
      sub: [],
      is_badge: false,
      can: "task_unknown",
    },
    // ================== المجموعة: حسابات ==================
    {
      id: 133,
      groupTitle: "حسابات",
      name: "المعاملات الماليه",
      icon: <GrTransaction size={18} />,
      path: "/transactions",
      sub: [],
      can: "client_transaction_view",
    },
    {
      id: 499,
      groupTitle: "حسابات",
      name: "اسعار الاشتراكات",
      icon: <MdAttachMoney size={18} />,
      path: "/subscriptions-price",
      sub: [],
      can: "subscription_price_manage",
    },
    {
      id: 1226,
      groupTitle: "حسابات",
      name: "محافظ الموظفين",
      icon: <LuWallet size={18} />,
      path: "/user-wallet",
      sub: [],
      can: "wallet_view",
    },
    {
      id: 1221,
      groupTitle: "حسابات",
      name: "حركة المحافظ",
      icon: <TbTransform size={18} />,
      path: "/wallet-transaction",
      sub: [],
      can: "wallet_transactions",
    },
    {
      id: 40,
      groupTitle: "حسابات",
      name: "عروض الاشتراكات",
      icon: <BiSolidOffer size={18} />,
      path: "/offers",
      sub: [],
      can: "offers",
    },

    // ================== المجموعة: ادارة ==================
    {
      id: 120,
      groupTitle: "ادارة",
      name: "الوكلاء",
      icon: <LiaBroadcastTowerSolid size={18} />,
      path: "/clients",
      sub: [],
      can: "client_view",
    },
    {
      id: 9,
      groupTitle: "ادارة",
      name: "الكابينات و الاعمدة",
      icon: <TbServer2 size={18} />,
      path: "/cabinets",
      sub: [],
      can: "cabinet_view",
    },
    {
      id: 4,
      groupTitle: "ادارة",
      name: "الموظفين",
      icon: <HiOutlineBuildingOffice size={18} />,
      path: "/users",
      sub: [],
      can: "user_manage",
    },
    {
      id: 3,
      groupTitle: "ادارة",
      name: "الصلاحيات",
      icon: <RiShieldUserLine size={18} />,
      path: "/roles-permissions",
      sub: [],
      can: "management",
    },

    // ================== المجموعة: اعدادات ==================
    {
      id: 3790,
      groupTitle: "اعدادات",
      name: "المناطق ( الزون )",
      icon: <TbEaseInOutControlPoints size={18} />,
      path: "/ftth-panels",
      sub: [],
      roles: [],
      can: "",
    },
    {
      id: 14,
      groupTitle: "اعدادات",
      name: "خدمات الوكلاء",
      icon: <TbSocial size={18} />,
      path: "/subscription-service",
      sub: [],
      can: "client_subscription_service_view",
    },
    {
      id: 30,
      groupTitle: "اعدادات",
      name: "المتغيرات",
      icon: <VscVariableGroup size={18} />,
      path: "/variables",
      sub: [],
      can: "update_variables",
    },
    {
      id: 1128,
      groupTitle: "اعدادات",
      name: "رفع التطبيق",
      icon: <FaUpload size={20} />,
      path: "/apk",
      sub: [],
      can: "upload_apk",
    },
    {
      id: 3789,
      groupTitle: "اعدادات",
      name: "الأعلانات",
      icon: <TfiAnnouncement size={18} />,
      path: "/announcements",
      sub: [],
      can: "announcements",
    },
  ];
  const getNotificationCount = (id) => {
    switch (id) {
      case 11:
        return new_customer;
      case 12:
        return maintenance;
      case 20:
        return subscription_request;
      default:
        return 0;
    }
  };

  let currentGroup = "";

  const drawerLinks = (
    <Box m={1}>
      <List
        dense={false}
        sx={{
          "& .MuiListItem-root:hover": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
            borderRadius: "8px",
          },
          "& .Mui-selected": {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.primary.main,
            borderRadius: "8px",
            fontWeight: "bold",
          },
        }}
      >
        {links.map((item, index) => {
          if (!Can(item.can) && item.can !== "") return null;

          const hasSub = item.sub && item.sub.length > 0;
          const isMenuOpen = selectedID === index && open;

          let renderTitle = null;
          if (item.groupTitle && item.groupTitle !== currentGroup) {
            const isFirstGroup = currentGroup === "";
            currentGroup = item.groupTitle;
            renderTitle = (
              <React.Fragment>
                {!isFirstGroup && <Divider sx={{ my: 1, opacity: 0.6 }} />}{" "}
                <ListSubheader
                  disableSticky
                  sx={{
                    backgroundColor: "transparent",
                    lineHeight: "30px",
                    fontWeight: "bold",
                    fontSize: "0.85rem",
                    color: theme.palette.text.secondary,
                    mt: 1,
                    mb: 0.5,
                  }}
                >
                  {item.groupTitle}
                </ListSubheader>
              </React.Fragment>
            );
          }

          return (
            <React.Fragment key={index}>
              {renderTitle}

              <ListItem disablePadding>
                <ListItemButton
                  selected={item.path === "/" + pathname.split("/")[1]}
                  onClick={() => {
                    if (!hasSub) navigate(item.path);
                    if (index === selectedID) {
                      setOpen(!open);
                    } else {
                      setOpen(true);
                      setSelectedID(index);
                    }
                  }}
                >
                  <Badge
                    badgeContent={getNotificationCount(item.id)}
                    invisible={!item?.is_badge}
                    color="primary"
                    anchorOrigin={{ vertical: "top", horizontal: "left" }}
                  >
                    <ListItemIcon sx={{ minWidth: "25px" }}>
                      {item.icon}
                    </ListItemIcon>
                  </Badge>

                  <ListItemText
                    sx={{ fontSize: "0.8rem" }}
                    disableTypography={true}
                    primary={item.name}
                  />

                  {hasSub ? isMenuOpen ? <ExpandLess /> : <ExpandMore /> : null}
                </ListItemButton>
              </ListItem>

              {hasSub && (
                <Collapse in={isMenuOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.sub.map((subItem) => {
                      if (!Can(subItem.can) && subItem.can !== "") return null;

                      return (
                        <ListItemButton
                          key={subItem.id}
                          sx={{ pl: 4 }}
                          selected={pathname === subItem.path}
                          onClick={() => navigate(subItem.path)}
                        >
                          {subItem.icon && (
                            <ListItemIcon sx={{ minWidth: "25px" }}>
                              {subItem.icon}
                            </ListItemIcon>
                          )}
                          <ListItemText
                            primary={subItem.name}
                            disableTypography={true}
                            sx={{ fontSize: "0.75rem", opacity: 0.8 }}
                          />
                        </ListItemButton>
                      );
                    })}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          );
        })}
      </List>
    </Box>
  );
  const drawerViewAndScroll = (
    <>
      <Box>
        <Box
          sx={{ display: "flex", mx: "auto", justifyContent: "center", mt: 1 }}
        >
          <img
            src={require("../../../assets/images/ftth.jpeg")}
            height={55}
            alt="logo"
          />
        </Box>
      </Box>
      <BrowserView>
        <PerfectScrollbar
          component="div"
          style={
            {
              // height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 88px)",
              // paddingLeft: "10px",
              // paddingRight: "10px",
            }
          }
        >
          {drawerLinks}
        </PerfectScrollbar>
      </BrowserView>
      <MobileView>
        <Box sx={{ px: 2 }}>{drawerLinks}</Box>
      </MobileView>
    </>
  );

  useEffect(() => {
    if (matchUpMd) {
      dispatch(setDrawer());
    }
  }, [matchUpMd]);

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { md: 0 }, width: drawerOpen ? drawerWidth : "0px" }}
      aria-label="sidebar"
    >
      {permissions.length > 0 && (
        <Drawer
          dir="rtl"
          variant={matchUpMd ? "persistent" : "temporary"}
          anchor="left"
          open={drawerOpen}
          onClose={() => dispatch(setDrawer())}
          sx={{
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              borderRight: "none",
            },
          }}
          ModalProps={{ keepMounted: true }}
          color="inherit"
        >
          {drawerViewAndScroll}
        </Drawer>
      )}
    </Box>
  );
};

export default SideBar;
